// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { operatorId } from './Operator';
import { z } from 'zod';
export const devicePlotOverrideId = (z.number());
export const devicePlotOverride = z.object({
    id: devicePlotOverrideId,
    device_id: deviceId,
    affordance_id: z.string(),
    override: z.unknown(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const devicePlotOverrideInitializer = z.object({
    id: devicePlotOverrideId.optional(),
    device_id: deviceId,
    affordance_id: z.string(),
    override: z.unknown().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const devicePlotOverrideMutator = z.object({
    id: devicePlotOverrideId.optional(),
    device_id: deviceId.optional(),
    affordance_id: z.string().optional(),
    override: z.unknown().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=DevicePlotOverride.js.map